import propTypes from "prop-types";
import React from "react";
import { Redirect, Route } from "react-router-dom";

const PublicRoute = ({
  component,
  exact = false,
  path,
  restricted,
}) => {
  return (
    <Route
      exact={exact}
      path={path}
      render={(props) =>
        restricted  ? (
          <Redirect
            to={{
              pathname: "/home",
              state: { from: props.location },
            }}
          />
        ) : (
          React.createElement(component, props)
        )
      }
    />
  );
};

PublicRoute.propTypes = {
  component: propTypes.oneOfType([propTypes.object, propTypes.func]).isRequired,
  exact: propTypes.bool,
  path: propTypes.oneOfType([
    propTypes.object,
    propTypes.array,
    propTypes.string,
  ]).isRequired,
  location: propTypes.object,
};

export default PublicRoute;
